import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { isEmailOTPWalletConnector } from '@dynamic-labs/multi-wallet';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { useViewContext } from '../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/sdk-api';
import '../../config/ApiEndpoint.js';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'react-dom';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../components/IconButton/IconButton.js';
import { OTPVerificationView } from '../../components/OTPVerificationView/OTPVerificationView.js';
import 'ethers';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import { useMutation } from '../../utils/hooks/useMutation/useMutation.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';

const EmailWalletOTPVerificationView = () => {
    const { setView } = useViewContext();
    const [error, setError] = useState();
    const { selectedWalletConnector: emailWalletConnector, termsOfServiceUrl, privacyPolicyUrl, clearStatesOnBackClick, } = useInternalDynamicContext();
    if (!emailWalletConnector ||
        !isEmailOTPWalletConnector(emailWalletConnector)) {
        throw new Error('Current wallet is not EmailWalletConnector');
    }
    const { email } = emailWalletConnector;
    if (!email) {
        throw new Error('EmailWalletOtpVerificationView requires a email');
    }
    const handleBackClick = () => {
        emailWalletConnector.cancelPreviousEmail();
        clearStatesOnBackClick();
        setView('login-with-email-or-wallet');
    };
    const { data: isValid, isLoading, mutate: onSubmit, } = useMutation((otp) => emailWalletConnector.verifyOneTimePassword(otp), {
        onFailure: (error) => setError(error),
    });
    return (jsx(OTPVerificationView, { email: email, error: error, onClickBack: handleBackClick, isLoading: isLoading, onPinComplete: onSubmit, isValid: isValid === true, termsOfServiceUrl: termsOfServiceUrl, privacyPolicyUrl: privacyPolicyUrl, onPinChange: () => setError(undefined), onClickEditEmail: handleBackClick, displayPoweredByDynamic: true }));
};

export { EmailWalletOTPVerificationView };
